module.exports = __webpack_public_path__ + "static/media/sfc logo.3692500a.png";